import React, { useState, useEffect, Fragment } from "react";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { FormControl, Select } from "@mui/material";
import { TextField } from "@mui/material";
import { MenuItem } from "@mui/material";

const AutoVersionIncrement = (props: {
  disableIncrement: boolean;
  version: string;
  originalVersion: string;
  versionIncrement: string;
  onChange: (version: string, versionIncrement: string) => void;
}) => {
  const [version, setVersion] = useState("");
  const [versionIncrement, setVersionIncrement] = useState("");

  const incrementVersion = (value: string) => {
    // console.log("props", props);
    let _version = 0.0;
    if (value) {
      if (value === "Major") {
        _version = Math.floor(parseFloat(props.originalVersion) + 1.0);
      } else if (value === "Minor") {
        _version = parseFloat(props.originalVersion) + 0.1;
      } else if (value === "No Change") {
        _version = parseFloat(props.originalVersion);
      }
      props.onChange(_version?.toFixed(1) + "", value);
    }
  };

  useEffect(() => {
    if (props.version) {
      setVersion(props.version);
    }
  }, [props.version]);

  useEffect(() => {
    setVersionIncrement(props.versionIncrement);
  }, [props.versionIncrement]);

  return (
    <Grid container spacing={2} sx={{ width: "100%" }}>
      <Grid xs={6}>
        <h4
          style={{
            color: "lightgrey",
            fontWeight: "400",
            fontStyle: "italic",
            margin: "0.5rem 0",
          }}
        >
          Version
        </h4>
        <TextField
          disabled
          fullWidth
          variant="filled"
          size="small"
          id="version"
          value={version}
        />
      </Grid>
      <Grid xs={6}>
        <h4
          style={{
            color: "lightgrey",
            fontWeight: "400",
            fontStyle: "italic",
            margin: "0.5rem 0",
          }}
        >
          Version Change
        </h4>
        <FormControl variant="filled" sx={{ minWidth: 200, width: "100%" }}>
          <Select
            id="versionChange"
            value={versionIncrement}
            disabled={props.disableIncrement}
            onChange={(e) => incrementVersion(e.target.value)}
          >
            <MenuItem value="No Change">No Change</MenuItem>
            <MenuItem value="Minor">Minor</MenuItem>
            <MenuItem value="Major">Major</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AutoVersionIncrement;
